<template>
    <div>
        <v-card raised>
            <v-card-title>
                User Lookup
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :loading="loadingUserReceipts" :headers="headers" :items="userreceipts" :search="search" class="elevation-1">
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                search: '',
                appURL: process.env.MIX_APP_URL,
                loadingUserReceipts: false,
                userreceipts: [],
                headers: [
                    { text: 'UIN', align: 'left', sortable: true, value: 'uin',},
                    { text: 'Name', align: 'left', sortable: true, value: 'customer_name',},
                    { text: 'Contact', value: 'provided_phone' },
                    { text: 'Office', value: 'ofc_comment' },
                    { text: 'V1 Plate Number', value: 'v1_plate_number' },
                    { text: 'V2 Plate Number', value: 'v2_plate_number' },
                    { text: 'V3 Plate Number', value: 'v3_plate_number' },
                    { text: 'Permit Series', value: 'permit_number_series_code' },
                    { text: 'Permit Number', value: 'permit_number' },
                    { text: 'Transaction ID', value: 'transactionid' },
                    { text: 'Permit Year', value: 'permit_year' },
                    { text: 'Issued Date', value: 'issued_date' },
                    { text: 'Payment Type', value: 'payment_type' },
                ],
            }
        },
        created() {
            this.fetchUserReceipts();
        },
        methods: {
            fetchUserReceipts: function () {
                this.loadingUserReceipts = true;
                axios.get(this.appURL + '/api/userlookup')
                    .then((response) => {
                        if(response.status === 200)
                        {
                            this.userreceipts = response.data;
                        }
                        this.loadingUserReceipts = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.loadingUserReceipts = false;
                    });
            }
        }
    }
</script>
